import * as React from 'react';
import {Component, inject, observer, deps} from '../../lib/component';
import {HookIt} from '../hook-it';
import {TrackSchema} from '../../types/schema';
import {getCountryCode} from "../../lib/helpers";
import {EnvModel} from "../../modules/env/model";

export interface AddRemoveCompatProps {
    size?: number;
    className?: string;
    track: TrackSchema;
    removeOnly?: boolean;
    invert?: boolean;
    withLabel?: boolean;
    withLicense?: boolean;
    reverse?: boolean;
    i18n?: {
        hookd: string;
        unhookd: string;
        license: string;
    }
}

type State = {
    isLoading: boolean;
}

@inject(deps) @observer
export class AddRemoveCompat extends Component<AddRemoveCompatProps> {
    state: State = {
        isLoading: false,
    };

    render() {
        const {className, track, invert, removeOnly, size, reverse, withLabel, withLicense, i18n = AddRemoveCompat.i18n} = this.props;
        if (!track) return null;

        const {basket, ui} = this.props.model;
        const {addToBasket, removeFromBasket} = this.props.controller.basket;

        const isHookd = !ui.firstPaint && basket.isInBasket(track);

        const label = withLicense
            ? i18n.license
            : withLabel
                ? (isHookd ? i18n.hookd : i18n.unhookd)
                : void 0;

        return (
            <HookIt
                removeOnly={removeOnly}
                className={className}
                onClick={this.handleClick.bind(this, track, isHookd)}
                isHookd={isHookd}
                isSync={basket.isSyncing(track)}
                size={size}
                label={label}
                reverse={reverse}
                invert={invert}
                isloading={this.state.isLoading}
            />
        );
    }

    handleClick = async (track: TrackSchema, isHookd: boolean, event: React.MouseEvent<any>) => {
        if (isHookd) {
            return this.props.controller.basket.removeFromBasket(track);
        }

        this.setState({
          isLoading: true
        });
        let isRestricted = await this.isTrackRestricted(track);
        this.setState({
            isLoading: false
        });

        isRestricted ? this.props.controller.modal.showRestrictedModal() : this.props.controller.modal.showLicenseModal(track);
    };

    isTrackRestricted = async (track: TrackSchema) => {
        const env = new EnvModel();
        const country = await getCountryCode();

        let response = await fetch(env.apiUri + '/catalog/track/' + track.identity + '/available_in', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              'country': country,
            }),
            mode: 'cors',
        });

        let { data } = await response.json();
        return data.restricted
    };

    static i18n = {
        hookd: 'Remove from basket',
        unhookd: 'Add to basket',
        license: 'License'
    }
}